import { LevelState } from './styles';
import * as S from './styles';
import { badgeSizes, LevelNumberBadgeSize } from './sizes';

export type { LevelState };

interface LevelNumberBadgeProps {
  level: number;
  state: LevelState;
  size?: LevelNumberBadgeSize;
}

const LevelNumberBadge = ({ level, state, size = 'sm' }: LevelNumberBadgeProps) => {
  return (
    <S.Badge $size={badgeSizes[size]} data-testid="levelNumberBadge" $state={state}>
      {level}
    </S.Badge>
  );
};

export function getLevelState(levelNumber: number, currentLevelNumber: number): LevelState {
  return levelNumber > currentLevelNumber
    ? 'not-started'
    : levelNumber === currentLevelNumber
      ? 'in-progress'
      : 'completed';
}

export default LevelNumberBadge;
